module.exports = __webpack_public_path__ + "static/media/Tick-Box-Indeterminate.34d48708.svg";